// Author Liu Cui Cui
// Date 2022-08-25 18:12:08

import * as model from "@/model/sithMes/tpm/SithMesTpmWarningDataTwdModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesTpmWarningDataTwd(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_TPM_URL,
    })
    .buildStore()
